import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import { FormCheckboxInput } from '@divvy-web/skylab.form'
import { useFormContext } from '@divvy-web/skylab.react-hook-form'

import TermsAndConditionsLink from '@sputnik/components/TermsAndConditionsLink'
import { getIsDSABusinessOnly } from '@sputnik/components/utils'

import styles from './styles.module.scss'

interface FCRATermsProps {
  dsaVersion: string
}

const FCRATerms = ({ dsaVersion = '' }: FCRATermsProps) => {
  const [getClassName, makeTestId] = useNameFormatter('FCRATerms')
  const { control } = useFormContext()

  return (
    <div className={styles[getClassName('')]}>
      <FormCheckboxInput
        checkboxLabel={
          <FormattedMessage
            defaultMessage='I have read and agree to the following:'
            id='sputnik.FCRATerms__RNICJi'
          />
        }
        control={control}
        dataTestId={makeTestId('checkbox')}
        name='creditReportConsent'
      />
      <div>
        <ul className={styles[getClassName('list')]}>
          <li>
            <TermsAndConditionsLink
              alternateLinkString={
                <FormattedMessage
                  defaultMessage='{isBusinessOnly, select, 
                  true {Business credit report consent}
                  other {Credit report consent}
                  }'
                  id='sputnik.FCRATerms__b1sY5l'
                  values={{ isBusinessOnly: getIsDSABusinessOnly(dsaVersion) }}
                />
              }
              className={getClassName('credit-reporting-link')}
              dataTestId={makeTestId('credit-reporting-link')}
            />
          </li>
          <li>
            <FormattedMessage
              defaultMessage='I certify to the best of my knowledge that the information provided above is complete and correct.'
              id='sputnik.FCRATerms__kfpX/1'
            />
          </li>
        </ul>
      </div>
    </div>
  )
}

export default FCRATerms
